"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var PictureOfMe = function () { return (react_1["default"].createElement("div", { className: "PictureOfMe" },
    react_1["default"].createElement("img", { src: "images/mesound.jpg", height: 290 }))); };
exports["default"] = PictureOfMe;
